import axios from "axios"
import { ErrorLogService } from ".";

export const TenantService = Object.freeze({
  GetTenantDetails: async function () {
    var iterations = 0;
    do {
      try{
          iterations++;
          var result = await axios.get(window.appGlobals.API_URL + "home/GetTenantDetails");
          if(result !== undefined){
            return result;
          }
        }
      catch(exception){
        //Swallow error for now
      }
    }
    while(iterations < 10);
    //If the loop isn't successful than log an error
    ErrorLogService.LogException("Unable to retrieve tenant details");
  }
})
